// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IPatientRegistrationRequestModel {
    static getAttributeTypeMap() {
        return IPatientRegistrationRequestModel.attributeTypeMap;
    }
}
IPatientRegistrationRequestModel.discriminator = undefined;
IPatientRegistrationRequestModel.attributeTypeMap = [
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "ScriptsPatientAccountPatientRegistrationIPatientRegistrationUserContactInfoRequestModel"
    },
    {
        "name": "dob",
        "baseName": "dob",
        "type": "Date"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "password",
        "baseName": "password",
        "type": "string"
    },
    {
        "name": "sendEmail",
        "baseName": "sendEmail",
        "type": "boolean"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    }
];
//# sourceMappingURL=iPatientRegistrationRequestModel.js.map